export const emptyInvoiceItem = (vat_percentage?: number) => {
  return {
    item: '',
    amount: '',
    price: '',
    ...(vat_percentage !== null && vat_percentage !== undefined && { vat_percentage }),
  };
};
